module.exports = __webpack_public_path__ + "img/img23.0af3e6aa.svg";